import { MenuCategoryWithProducts } from "./menu-category-with-products";

export class PublicProductListGroupedByCategoryResponse {
    public categories: MenuCategoryWithProducts[] = [];

    constructor() {
    }
}